export const USER_ROLES = {
  REP: "REP",
  OWNER: "OWNER",
  MANAGER: "MANAGER",
  ADMIN: "ADMIN",
  TECH: "TECH",
  AP_ONLY: "AP_ONLY",
};

export const ROLE_TO_LABEL = {
  [USER_ROLES.ADMIN]: "Admin",
  [USER_ROLES.OWNER]: "Manager",
  [USER_ROLES.MANAGER]: "Manager (legacy)",
  [USER_ROLES.REP]: "Representative (legacy)",
  [USER_ROLES.TECH]: "Technician",
  [USER_ROLES.AP_ONLY]: "AP only",
};

const ROLE_TO_BADGE_COLOR: Record<
  string,
  "purple" | "blue" | "green" | "orange" | "cyan" | "sand"
> = {
  [USER_ROLES.ADMIN]: "purple",
  [USER_ROLES.OWNER]: "blue",
  [USER_ROLES.MANAGER]: "green",
  [USER_ROLES.REP]: "orange",
  [USER_ROLES.TECH]: "cyan",
};

const roleKey = (role: string) =>
  role.toUpperCase() as keyof typeof ROLE_TO_LABEL;

export const roleLabel = (role: string) => ROLE_TO_LABEL[roleKey(role)] ?? role;

export const roleBadgeVariant = (role: string) =>
  ROLE_TO_BADGE_COLOR[roleKey(role)] ?? "sand";

export const ROLE_DISPLAY_ORDER = [
  USER_ROLES.ADMIN,
  USER_ROLES.OWNER,
  USER_ROLES.MANAGER,
  USER_ROLES.REP,
  USER_ROLES.AP_ONLY,
  USER_ROLES.TECH,
];

export const ROLE_OPTIONS = ROLE_DISPLAY_ORDER.filter(
  (role) => role !== USER_ROLES.MANAGER && role !== USER_ROLES.REP,
).map((role) => ({
  value: role,
  label: roleLabel(role),
}));
